import "./home.less"
import initMenus from "./menus"
import initCalculator from "./calculator"
import initCarousel, { initBannerLanguage } from "./carousel"
import initFooter from "./footer"
import initNewsletter from "./newsletter"
import initOfferForm from "./offer"
import initTranslate from "./translate"

// The home page is server-rendered HAML (app/views/welcome/home); this only adds behaviour.
const root = document.querySelector(".home-v2")

if (root) {
  root.classList.add("js")
  initMenus(root)

  const calculator = document.getElementById("hv-calc")
  if (calculator) initCalculator(calculator)

  root.querySelectorAll("[data-carousel]").forEach((carousel) => {
    initCarousel(carousel)
    // Before initTranslate, which reports the current language on start.
    initBannerLanguage(carousel)
  })

  const footer = root.querySelector(".hv-footer")
  if (footer) initFooter(footer)

  const offer = document.getElementById("hv-offer")
  if (offer) initOfferForm(offer)

  const newsletter = document.getElementById("hv-newsletter")
  if (newsletter) initNewsletter(newsletter)

  const lang = root.querySelector(".hv-lang")
  if (lang) initTranslate(lang)

  if (typeof window.ga === "function") {
    window.ga("set", "location", window.location.href)
    window.ga("send", "pageview")
  }
}
